import { BrowserRouter, useRoutes } from 'react-router-dom'
import MainLayout from './layouts/main-layout'
import {
  Container,
  SnackbarProvider,
  DialogProvider,
  useInitLang
} from '@yuno/dashboard-container-mfe'
import Routes from './utils/routes'
import ConnectionsPage from './pages/connections'
import ConnectionDetails from './pages/connection-details'
import { FiltersProvider } from './context/filters-context'
import { I18nextProvider } from 'react-i18next'
import i18n from 'i18next'

import en from './lang/en.json'
import es from './lang/es.json'
import pt from './lang/pt.json'

const mainRoutes = {
  path: '/connections',
  element: <MainLayout />,
  children: [
    { path: Routes.CONNECTIONS, element: <ConnectionsPage /> },
    { path: Routes.CONNECTIONS_DETAILS, element: <ConnectionDetails /> },
  ],
}

const Routing = () => {
  const routing = useRoutes([mainRoutes])
  return <>{routing}</>
}

export default function Root() {

  const i18Instance = useInitLang({ i18n, en, es, pt })

  return (
    <Container content>
      <DialogProvider>
        <SnackbarProvider>
          <I18nextProvider i18n={i18Instance}>
            <BrowserRouter>
              <FiltersProvider>
                <Routing />
              </FiltersProvider>
            </BrowserRouter>
          </I18nextProvider>
        </SnackbarProvider>
      </DialogProvider>
    </Container>
  )
}
